import { Col, Form, Row } from "react-bootstrap";

import { humanizeKey, THEME_COLOR_KEYS } from "../utils/content.utils";

const ThemeEditor = ({ theme = {}, disabled = false, onChange }) => {
  const handleColorChange = (key, value) => {
    onChange({
      ...(theme && typeof theme === "object" ? theme : {}),
      [key]: value,
    });
  };

  return (
    <div className="mb-4">
      <h5 className="mb-3">Theme</h5>
      <Row>
        {THEME_COLOR_KEYS.map((key) => {
          const value = theme?.[key] || "";
          return (
            <Col md={3} sm={6} key={key}>
              <Form.Group className="mb-3">
                <Form.Label>{humanizeKey(key)}</Form.Label>
                <div className="d-flex gap-2 align-items-center">
                  <Form.Control
                    type="color"
                    value={/^#[0-9A-Fa-f]{6}$/.test(value) ? value : "#000000"}
                    onChange={(e) => handleColorChange(key, e.target.value)}
                    disabled={disabled}
                    title={value}
                    style={{ width: 48, height: 38, padding: 2 }}
                  />
                  <Form.Control
                    type="text"
                    value={value}
                    onChange={(e) => handleColorChange(key, e.target.value)}
                    placeholder="#000000"
                    disabled={disabled}
                  />
                </div>
              </Form.Group>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default ThemeEditor;
